import { AxiosResponse } from 'axios';
import { doorClient } from '.';

function resolve<T>(promise: Promise<AxiosResponse<T>>) {
  return promise.then((response) => {
    return response.data;
  });
}
export function reportCase(body: Feedback.ReportCase) {
  return resolve(doorClient.post('/oversea-user-voice/v1/case', body));
}

export interface CaseListParams {
  caseStatus: Feedback.CaseStatus[];
  feedback?: 1 | 2;
  pageNum: number;
  pageSize: number;
}

export interface CaseListResponse {
  caseBasicInfo: Feedback.CaseBasicInfo[];
  caseStatusCount: {
    caseStatus: Feedback.CaseStatus;
    count: number;
  }[];
  pageNum: number;
  pageSize: number;
}

export function caseList(params: CaseListParams) {
  return resolve(doorClient.post<CaseListResponse>('/oversea-user-voice/v1/case/list', params));
}

export interface CaseResponse {
  caseBasicInfo: Feedback.CaseBasicInfo;
  operateLog: Feedback.CaseOperateLog[];
}

export function caseDetail(caseId: number) {
  return resolve(doorClient.get<CaseResponse>(`/oversea-user-voice/v1/case/${caseId}/detail`));
}

export function closeCase(caseId: number) {
  return resolve(doorClient.put(`/oversea-user-voice/v1/case/${caseId}/close`, null));
}

interface FeedbackBody {
  // 操作人id
  userId: number;
  // 反馈描述
  desc: string;
  // 操作人名称
  userName: string;
}

// 重新提交反馈
export function resubmitFeedback(caseId: number, body: FeedbackBody) {
  return resolve(
    doorClient.post<CaseListResponse>(`/oversea-user-voice/v1/case/${caseId}/feedback`, body),
  );
}
